import Button from "hardcover-ui/components/Button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "hardcover-ui/components/Dropdown";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import plus from "icons/solid/circle-plus.svg";
import ellipsis from "icons/solid/ellipsis.svg";
import share from "icons/solid/share.svg";
import stars from "icons/solid/stars.svg";
import React from "react";

type StatSize = "sm" | "md" | "lg" | "xl";

interface StatWrapperProps {
  children: React.ReactNode;
  size?: StatSize;
  title: React.ReactNode;
  noPadding?: boolean;
  gradient?: boolean;
  isSupporter?: boolean;
  noDropdown?: boolean;
  onShare?: () => void;
  onAddToDashboard?: () => void;
}

const sizeClasses: Record<StatSize, string> = {
  sm: "col-span-1",
  md: "col-span-2",
  lg: "col-span-3",
  xl: "col-span-4",
};

export default function StatWrapper({
  children,
  size = "sm",
  title,
  noPadding = false,
  gradient = false,
  isSupporter = false,
  noDropdown = false,
  onShare,
  onAddToDashboard,
}: StatWrapperProps) {
  return (
    <div
      className={`
      text-card-foreground
      rounded-lg shadow-md
      h-full min-h-[200px]
      md:${sizeClasses[size]}
      flex flex-col
      border border-secondary dark:border-card
      ${noPadding ? "" : "p-4"}
      ${
        gradient
          ? "bg-linear-to-b from-transparent dark:to-card to-background backdrop-blur-md dark:border-none"
          : "dark:bg-card bg-background"
      }
    `}
    >
      <div className="flex justify-between items-center">
        <Text className="z-10" variant="secondary">
          {title}
        </Text>
        {/* TODO: #1497 - Implement share link */}
        {!noDropdown && (onShare || onAddToDashboard) && (
          <DropdownMenu>
            <DropdownMenuTrigger className="hover:opacity-80 p-1 rounded-sm transition-opacity">
              <Icon icon={ellipsis} className="h-4 w-4 text-secondary" />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuItem onClick={onShare}>
                <Icon icon={share} size="sm" />
                Share
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onAddToDashboard}>
                <Icon icon={plus} size="sm" /> Add to Dashboard
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>

      <div className="grow flex items-center justify-center">
        {children}
      </div>

      {isSupporter && (
        <div className=" mt-4 -mx-4 -mb-4 bg-primary p-2 text-primary-foreground text-center text-sm rounded-b-lg">
          <Icon
            icon={stars}
            className="h-3 w-3 text-primary-foreground -mt-1"
          />{" "}
          This is a Supporter stat. If you want to see how it looks like with
          your data,
          <Button
            variant="link"
            className="underline"
            size="sm"
            as={{ element: "link", props: { href: "/supporter" } }}
          >
            Become a Supporter
          </Button>
        </div>
      )}
    </div>
  );
}
